<template>
  <div style="margin-top:10px">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
          placeholder="公司名"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="operationName" >
        <el-select v-model="queryParams.operationName" filterable multiple placeholder="运营商" @change="search" clearable>
          <el-option v-for="item in operationNames" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download" v-hasPermi="['card:flow:day:export']" @click="exportFlow">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" min-width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center" min-width="180" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="operationName" label="运营商" align="center" min-width="220" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="dayTime" label="时间" align="center" min-width="180" >
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.dayTime,'{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="dayFlow" label="日流量（M）" align="center" min-width="100" ></el-table-column>
      <el-table-column prop="monthFlow" label="当月周期流量（M）" align="center" min-width="100" ></el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { cardFlowDay } from "@/api/api.js";
import { agentTreeList } from "@/api/api.js"; //代理商
import { exportFlowDay } from "@/api/api.js"; //代理商
export default {
  data() {
    return{
      queryParams:{
          iccid:undefined,
          operationName:undefined
      },
      // 代理商
      agentTree: [],
      dateRange:[],
      tableData:[],
      operationNames:[
        {
          value: "中国电信",
          label: "中国电信"
        },
        {
          value: "中国移动",
          label: "中国移动"
        },
        {
          value: "中国联通",
          label: "中国联通"
        },
      ],
      page: 1,
      pageSize: 20,
      total:0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    //代理商列表
    agentTreeListMethod(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 初始化数据
    initData(){
      let params = {
        model:{
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      cardFlowDay(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total
      })
    },
    search(){
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    exportFlow(){
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange),
      };
      this.$alert("确定导出历史流量吗？", "历史流量导出", {
        confirmButtonText: "确定"
      }).then(() => {
        exportFlowDay(params).then(res => {
          this.$notify({
              title: "成功",
              message: "历史流量导出成功，请在任务中心查看",
              type: "success",
              offset:30
            });
        });
      });
    },
    // 详情跳转
    infoRow(row){
      this.$router.push('/order/invoiceDetail/' + row.id);
    },
  },
  created() {
      this.search();
      this.agentTreeListMethod();
  },
  mounted() {

  },

};
</script>


